type SettlementWeightDetail = {
  unit_weight?: number | string | null;
  quantity?: number | string | null;
  kilos?: number | string | null;
};

export function hasSettlementKilosMismatch(detail: SettlementWeightDetail) {
  const weight = Number(detail.unit_weight);
  const quantity = Number(detail.quantity);
  const kilos = Number(detail.kilos);
  // Missing/zero weight and quantity have their own validation warnings.
  if (
    !Number.isFinite(weight) ||
    weight <= 0 ||
    !Number.isFinite(quantity) ||
    quantity <= 0
  )
    return false;
  if (detail.kilos == null || detail.kilos === '' || !Number.isFinite(kilos)) {
    return true;
  }
  const expected = weight * quantity;
  // Allow only floating-point arithmetic noise, not a business tolerance.
  return (
    Math.abs(kilos - expected) >
    32 * Number.EPSILON * Math.max(1, Math.abs(kilos), Math.abs(expected))
  );
}
